<br>
<button (click)="openDocumentUploader()" class="btn btn-lg btn-primary">
    <span class="indicator-label text-dark">Aggiungi File</span>
</button>
<br>
<app-data-table [data]="dataSource" [columns]="columns" [displayedColumns]="displayedColumns"
    [actions]="actions" sortActive=""></app-data-table>